import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorComponent } from '#pplx/frontend/error-ui/ErrorComponent.js';
import { reloadWindow } from '#pplx/frontend/platform-components/reloadWindow.js';
import classNames from 'classnames';
import React, { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
export const ErrorFallback = React.memo(function ErrorFallback({ fullWidth, retryFn, className, errorCode, isReconnect, }) {
    const { $t } = useIntl();
    const reload = useCallback(() => {
        reloadWindow('error retry');
    }, []);
    const retryLabel = useMemo(() => isReconnect
        ? $t({
            defaultMessage: 'Refresh',
            description: 'Button label to refresh the page after a connection error',
            id: 'e19dff629b',
        })
        : undefined, [isReconnect, $t]);
    const title = (() => {
        switch (errorCode) {
            case 'FETCHER_SSE_OFFLINE_ERROR':
                return $t({
                    defaultMessage: 'Unstable internet, check your connection',
                    id: 'a00b4b1d2d',
                    description: 'Text in the Error Fallback error page section',
                });
            case 'FETCHER_SSE_NETWORK_ERROR':
                return $t({
                    defaultMessage: 'Sorry, a network error occurred',
                    id: 'fde621c084',
                    description: 'Error shown when a network error occurs during SSE streaming but the browser reports it is still online',
                });
            case 'FETCHER_SSE_NO_STATUS_CODE_ERROR':
                return $t({
                    defaultMessage: 'Sorry, connection lost',
                    description: 'Text in the Error Fallback error page section',
                    id: 'ca7f32f918',
                });
            case 'THREAD_PARTIAL_LOAD_ERROR':
                return $t({
                    defaultMessage: 'Sorry, could not load the rest of the thread',
                    id: '881b576900',
                    description: 'Text in the Error Fallback error page section',
                });
            default:
                return $t({
                    defaultMessage: 'Sorry, something went wrong',
                    id: 'd052e3b84f',
                    description: 'Text in the Error Fallback error page section',
                });
        }
    })();
    return (_jsx("div", { className: classNames('max-w-threadContentWidth mx-auto', {
            'w-full': fullWidth,
        }, className), children: _jsx(ErrorComponent
        // Aligns banner with floating footer
        , { 
            // Aligns banner with floating footer
            className: classNames('mx-4 md:mx-0', {
                'bg-super-strong': errorCode === 'FETCHER_SSE_OFFLINE_ERROR',
            }), title: title, retryFn: retryFn ?? reload, retryLabel: retryLabel }) }));
});
//# sourceMappingURL=ErrorFallback.js.map